import React from 'react';

const UsersAvatarIcon: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
      fill="#001C3D"
      fillOpacity="0.08"
    />
    <path
      d="M11.9984 6.63281C10.5718 6.63281 9.41536 7.78928 9.41536 9.21585C9.41536 10.6424 10.5718 11.7989 11.9984 11.7989C13.425 11.7989 14.5814 10.6424 14.5814 9.21585C14.5814 7.78928 13.425 6.63281 11.9984 6.63281Z"
      fill="#9DA4AE"
    />
    <path
      d="M10.2885 12.7561C9.55774 12.7561 8.88156 13.1428 8.51101 13.7727L8.16639 14.3584C7.88341 14.8394 7.75783 15.4078 7.87676 15.926C8.00193 16.4713 8.3919 16.9163 9.02194 17.079C10.6861 17.5089 13.3115 17.5089 14.9757 17.079C15.6057 16.9163 15.9957 16.4713 16.1209 15.926C16.2398 15.4078 16.1142 14.8394 15.8312 14.3584L15.4866 13.7727C15.1161 13.1428 14.4399 12.7561 13.7091 12.7561H10.2885Z"
      fill="#9DA4AE"
    />
    <path
      d="M7.32417 13.8183C7.37646 13.7294 7.31237 13.6174 7.20925 13.6174H6.57708C6.04764 13.6174 5.55773 13.8975 5.28926 14.3539L5.06995 14.7266C4.87165 15.0637 4.77693 15.4727 4.86514 15.857C4.95959 16.2685 5.25726 16.6051 5.72563 16.7261C6.09046 16.8204 6.5198 16.8823 6.96874 16.9134C7.07555 16.9208 7.14566 16.8032 7.09871 16.7069C7.01278 16.5308 6.94693 16.344 6.90233 16.1497C6.71436 15.3307 6.92186 14.5021 7.30472 13.8513L7.32417 13.8183Z"
      fill="#9DA4AE"
    />
    <path
      d="M16.8994 16.7069C16.8524 16.8031 16.9226 16.9208 17.0294 16.9134C17.478 16.8823 17.9072 16.8204 18.272 16.7261C18.7403 16.6051 19.038 16.2685 19.1324 15.857C19.2207 15.4727 19.1259 15.0637 18.9276 14.7266L18.7083 14.3539C18.4399 13.8975 17.95 13.6174 17.4205 13.6174H16.7888C16.6857 13.6174 16.6216 13.7294 16.6739 13.8183L16.6934 13.8513C17.0762 14.5021 17.2837 15.3307 17.0957 16.1497C17.0512 16.344 16.9853 16.5308 16.8994 16.7069Z"
      fill="#9DA4AE"
    />
    <path
      d="M16.332 9.8328C15.4116 9.8328 14.6654 10.579 14.6654 11.4995C14.6654 12.4199 15.4116 13.1661 16.332 13.1661C17.2525 13.1661 17.9987 12.4199 17.9987 11.4995C17.9987 10.579 17.2525 9.8328 16.332 9.8328Z"
      fill="#9DA4AE"
    />
    <path
      d="M7.66536 9.8328C6.74489 9.8328 5.9987 10.579 5.9987 11.4995C5.9987 12.4199 6.74489 13.1661 7.66536 13.1661C8.58584 13.1661 9.33203 12.4199 9.33203 11.4995C9.33203 10.579 8.58584 9.8328 7.66536 9.8328Z"
      fill="#9DA4AE"
    />
  </svg>
);

export default UsersAvatarIcon;
